function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10903_6754)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 552,
  height: 800,
  fill: "url(#paint0_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.9844 45V605.306",
  stroke: "url(#paint1_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.5 45V605.306",
  stroke: "url(#paint2_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.016 45V605.306",
  stroke: "url(#paint3_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.539 45V605.306",
  stroke: "url(#paint4_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.055 45V605.306",
  stroke: "url(#paint5_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M385.57 45V605.306",
  stroke: "url(#paint6_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M455.844 45V697",
  stroke: "url(#paint7_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526.844 45V697",
  stroke: "url(#paint8_linear_10903_6754)"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M-87 429.637L671.048 429.637",
  stroke: "url(#paint9_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 501.637L671.048 501.637",
  stroke: "url(#paint10_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 581.637L671.048 581.637",
  stroke: "url(#paint11_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 365.531L671.048 365.531",
  stroke: "url(#paint12_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 301.426L671.048 301.426",
  stroke: "url(#paint13_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 237.32L671.048 237.32",
  stroke: "url(#paint14_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 173.213L671.048 173.213",
  stroke: "url(#paint15_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 109.105L671.048 109.105",
  stroke: "url(#paint16_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 45L671.048 45",
  stroke: "url(#paint17_linear_10903_6754)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 454.802,
  cy: 347.601,
  r: 10.257,
  fill: "url(#paint18_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173.373,
  cy: 484.145,
  r: 40.3868,
  fill: "url(#paint19_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 563.954,
  cy: 209.528,
  r: 24.5949,
  fill: "url(#paint20_radial_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M421 662.649C421 639.12 437.56 620.059 458 620.059C478.441 620.059 495 639.12 495 662.649C495 686.177 478.441 705.238 458 705.238C437.56 705.238 421 686.177 421 662.649Z",
  fill: "url(#paint21_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 506.238,
  y: 243.305,
  width: 2.31621,
  height: 97.2809,
  fill: "url(#paint22_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 507.455,
  cy: 243.361,
  r: 13.9545,
  fill: "url(#paint23_radial_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 507.453,
  cy: 243.359,
  r: 4.21881,
  fill: "url(#paint24_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.5 394.355C59.3177 345.873 -69.5 351.355 -163 440.855V771.422L668.5 785.422C705.333 723.422 780.724 480.023 688 530.355C343.5 717.355 272 455.355 153.5 394.355Z",
  fill: "url(#paint25_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 409.422,
  y: 280.328,
  width: 0.903823,
  height: 70.4982,
  fill: "url(#paint26_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 410.013,
  cy: 280.013,
  r: 6.0125,
  fill: "url(#paint27_radial_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 410.013,
  cy: 280.013,
  r: 1.81773,
  fill: "#EDFAFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237 645C351.875 645 445 553.666 445 441C445 328.334 351.875 237 237 237C122.125 237 29 328.334 29 441C29 553.666 122.125 645 237 645Z",
  fill: "#EED0FD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.513 487.089C496.279 487.089 524.463 458.908 524.463 424.144C524.463 389.381 496.279 361.199 461.513 361.199C426.747 361.199 398.563 389.381 398.563 424.144C398.563 458.908 426.747 487.089 461.513 487.089Z",
  fill: "#EAF8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.3094 455.309C40.3922 446.601 35.0207 437.853 26.3118 435.771C17.6029 433.688 8.85449 439.059 6.7717 447.768C4.68892 456.476 10.0604 465.223 18.7693 467.306C27.4782 469.389 36.2266 464.018 38.3094 455.309Z",
  fill: "#EAF8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438.492 221.994C439.642 217.187 436.677 212.358 431.869 211.208C427.061 210.058 422.232 213.023 421.082 217.831C419.932 222.638 422.897 227.467 427.705 228.617C432.513 229.767 437.343 226.801 438.492 221.994Z",
  fill: "#EAF8FF"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M295.042 347.75C295.042 349.43 294.717 351.055 294.122 352.572H242.495C242.441 352.545 242.414 352.518 242.387 352.464C242.387 352.518 242.36 352.545 242.36 352.572C242.36 352.572 70.0005 353.682 70.0005 352.274C70.0005 337.701 81.1213 325.891 94.8668 325.891C98.0867 325.891 101.144 326.541 103.958 327.706C106.583 325.485 109.911 324.157 113.51 324.157C118.732 324.157 123.359 326.92 126.146 331.173C129.88 322.938 138.89 316.573 150.146 314.325C153.069 313.701 156.18 313.376 159.373 313.376C161.348 313.376 163.269 313.485 165.164 313.729C172.388 299.616 186.512 290 202.747 290C223.528 290 240.845 305.738 244.714 326.568C247.041 325.024 249.801 324.157 252.75 324.157C258.649 324.157 263.79 327.706 266.333 332.906C268.877 331.985 271.718 331.444 274.721 331.444C285.923 331.444 295.042 338.757 295.042 347.75Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M386.238 349.022C386.238 350.383 385.977 351.701 385.5 352.946H343.448C343.419 352.917 343.404 352.888 343.376 352.859C343.376 352.888 343.361 352.917 343.347 352.946C343.347 352.946 342.218 352.946 340.179 352.975C319.362 353.091 202.999 353.743 202.999 352.714C202.999 340.839 212.069 331.224 223.251 331.224C225.87 331.224 228.372 331.745 230.658 332.701C232.784 330.876 235.504 329.805 238.44 329.805C242.693 329.805 246.469 332.064 248.726 335.525C248.754 335.467 248.783 335.394 248.812 335.337C250.982 330.717 255.206 326.821 260.674 324.273C265.057 322.216 270.222 321.029 275.777 321.029C277.382 321.029 278.959 321.13 280.493 321.318C286.38 309.82 297.88 302 311.102 302C328.013 302 342.131 314.802 345.271 331.774C347.166 330.529 349.408 329.805 351.809 329.805C356.626 329.805 360.807 332.686 362.875 336.929C364.959 336.176 367.259 335.756 369.689 335.756C376.227 335.756 381.869 338.798 384.56 343.2C385.63 344.952 386.238 346.936 386.238 349.022Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 40.5,
  cy: 511.5,
  r: 13.5,
  fill: "url(#paint28_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M523.988 338.337C524.014 342.992 521.451 347.07 517.643 349.252L451.205 349.612C449.842 347.793 449.015 345.539 449 343.104C448.966 336.957 453.991 331.96 460.198 331.926C462.466 331.914 464.577 332.571 466.354 333.7C467.761 329.274 471.942 326.049 476.893 326.022C476.843 316.673 484.479 309.05 493.945 309C503.413 308.948 511.134 316.49 511.185 325.836C518.206 325.798 523.947 331.384 523.985 338.337H523.988Z",
  fill: "#CEF2FF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M93.9999 219.781C94.0165 222.762 92.4101 225.372 90.0232 226.769L48.3822 227C47.5275 225.835 47.0092 224.393 47.0001 222.834C46.9789 218.898 50.1281 215.699 54.0183 215.678C55.4398 215.67 56.7629 216.09 57.8767 216.813C58.7588 213.979 61.379 211.915 64.4828 211.898C64.4509 205.912 69.2368 201.032 75.17 201C81.1046 200.967 85.9436 205.795 85.9754 211.779C90.3763 211.754 93.9741 215.331 93.9984 219.781H93.9999Z",
  fill: "#CEF2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 196.971L252.19 258.561L181 213.551L277.95 144.051L349.04 196.971Z",
  fill: "url(#paint29_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 226.68L253.05 285.49L181.86 242.06L277.95 175.68L349.04 226.68Z",
  fill: "url(#paint30_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 259.81L253.14 316.19L181.86 274.43L277.86 210.91L349.04 259.81Z",
  fill: "url(#paint31_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.86 549.111L277.95 509.201V230.281L181.86 292.331V549.111Z",
  fill: "url(#paint32_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 480.641L277.95 446.131V230.281L349.04 277.951V480.641Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.95 188.492L181.86 253.852V274.432L277.95 210.852V188.492Z",
  fill: "url(#paint33_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 238.712L277.95 188.492V210.972L349.04 259.812V238.712Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.86 222.4L277.95 154.33V175.68L181.86 242.06V222.4Z",
  fill: "url(#paint34_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 206.63L277.95 154.33V175.68L349.04 226.68V206.63Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181 190.5L277.95 119V144.05L181 213.55V190.5Z",
  fill: "url(#paint35_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.04 173.45L277.95 119V144.05L349.04 196.97V173.45Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.66 273.237V425.317L236.77 426.257V457.537L265.02 444.147V256.617L238.66 273.237Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.72 301.589V466.229L215.6 455.629V287.789L193.72 301.589Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338 393.492L290.7 404.133V258.562L338 289.473V393.492Z",
  fill: "url(#paint36_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 464.176,
  y: 308.191,
  width: 2.032,
  height: 85.3441,
  fill: "url(#paint37_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 465.242,
  cy: 308.242,
  r: 12.2423,
  fill: "url(#paint38_radial_10903_6754)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 465.24,
  cy: 308.24,
  r: 3.70115,
  fill: "#EDFAFF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M312.61 386L312.777 528.41L345.358 534.237L364.975 418.037L312.61 386Z",
  fill: "url(#paint39_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M391.946 666.067L375.055 424.484L347.76 442.161L281.702 497.938L279.094 514.543L391.946 666.067Z",
  fill: "url(#paint40_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.002 652.648V692.313H475.914L475.914 652.658L16.002 652.648Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M423.384 635.791L423.847 612.277H68.2524L71.6188 632.395L423.384 635.791Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M393.732 602.869L393.998 588.775L101.271 587.633L103.083 602.869H393.732Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.234 584.294L371.194 571.844L121.502 572.365L122.723 585.161L371.234 584.294Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M358.781 571.176V562.328L137.024 561.078L137.339 571.176H358.781Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.344 560.27L345.769 561.077V551.668L334.951 551.727V543.764L328.622 543.784L328.14 538.243L318.72 538.184L318.553 531.451H312.469L312.154 526.54L306.347 526.501L306.071 521.835L299.437 521.796V516.629H293.246L293.334 514.542V510.723L375.052 424.484L318.129 386.374L312.607 386L351.32 417.761L200.425 516.629H195.533V521.166L189.627 521.136V525.713L183.504 525.664V531.451H175.955L176.122 537.308L168.523 537.258L168.582 544.296L159.231 544.325L159.507 552.632L148.069 552.691L148.344 560.27Z",
  fill: "url(#paint41_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M475.915 652.66L423.382 635.79L71.6168 632.395L16.0029 652.65L475.915 652.66Z",
  fill: "url(#paint42_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-38 697.395V746.395H542V697.407L-38 697.395Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542 697.395L475.75 676.583L32.1353 672.395L-38 697.382L542 697.395Z",
  fill: "url(#paint43_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-87 752V801H620L620 752.012L-87 752Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M620 752L539.244 731.189L-1.50752 727L-87 751.988L620 752Z",
  fill: "url(#paint44_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.2534 612.277L103.207 602.867H393.738L423.848 612.277H68.2534Z",
  fill: "url(#paint45_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101.272 587.633L124.286 585.124L371.231 584.297L393.999 588.775L101.272 587.633Z",
  fill: "url(#paint46_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M358.782 562.327L345.77 561.077L148.384 560.27L137.025 561.077L358.782 562.327Z",
  fill: "url(#paint47_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.07 552.692L159.498 551.589L334.952 550.398L345.77 551.668L148.07 552.692Z",
  fill: "url(#paint48_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.196 571.842L358.783 570.375L134.999 571.172L121.504 572.363L371.196 571.842Z",
  fill: "url(#paint49_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M400.684 356.223C400.684 350.381 404.795 345.648 409.87 345.648C414.945 345.648 419.056 350.381 419.056 356.223C419.056 362.064 414.945 366.797 409.87 366.797C404.795 366.797 400.684 362.064 400.684 356.223Z",
  fill: "url(#paint50_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M393 616.362C393 610.957 396.804 606.578 401.5 606.578C406.196 606.578 410 610.957 410 616.362C410 621.768 406.196 626.146 401.5 626.146C396.804 626.146 393 621.768 393 616.362Z",
  fill: "url(#paint51_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362 127.751C362 118.835 368.275 111.611 376.021 111.611C383.767 111.611 390.043 118.835 390.043 127.751C390.043 136.667 383.767 143.891 376.021 143.891C368.275 143.891 362 136.667 362 127.751Z",
  fill: "url(#paint52_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119 92.5C119 88.9091 121.685 86 125 86C128.315 86 131 88.9091 131 92.5C131 96.0909 128.315 99 125 99C121.685 99 119 96.0909 119 92.5Z",
  fill: "url(#paint53_linear_10903_6754)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_10903_6754)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M321 475.596C321 477.322 320.669 478.992 320.062 480.57H266.59C266.553 480.534 266.535 480.497 266.498 480.46C266.498 480.497 266.479 480.534 266.461 480.57C266.461 480.57 265.026 480.57 262.433 480.607C235.963 480.754 88 481.58 88 480.277C88 465.226 99.5332 453.039 113.752 453.039C117.081 453.039 120.264 453.7 123.17 454.911C125.874 452.598 129.332 451.24 133.066 451.24C138.474 451.24 143.275 454.103 146.144 458.49C146.181 458.417 146.218 458.325 146.255 458.251C149.014 452.396 154.385 447.459 161.338 444.229C166.911 441.623 173.478 440.117 180.541 440.117C182.583 440.117 184.588 440.246 186.538 440.485C194.024 425.911 208.648 416 225.46 416C246.963 416 264.916 432.225 268.907 453.736C271.317 452.158 274.168 451.24 277.222 451.24C283.347 451.24 288.663 454.893 291.293 460.27C293.942 459.316 296.867 458.784 299.957 458.784C308.271 458.784 315.445 462.638 318.866 468.218C320.227 470.439 321 472.953 321 475.596Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_10903_6754)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M334.988 343.337C335.014 347.992 332.451 352.07 328.643 354.252L262.205 354.612C260.842 352.793 260.015 350.539 260 348.104C259.966 341.957 264.991 336.96 271.198 336.926C273.466 336.914 275.577 337.571 277.354 338.7C278.761 334.274 282.942 331.049 287.893 331.022C287.843 321.673 295.479 314.05 304.945 314C314.413 313.948 322.134 321.49 322.185 330.836C329.206 330.798 334.947 336.384 334.985 343.337H334.988Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_10903_6754",
  x: 74,
  y: 402,
  width: 261,
  height: 93,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808415 0 0 0 0 0.94851 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10903_6754"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_10903_6754",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_10903_6754",
  x: 246,
  y: 300,
  width: 102.988,
  height: 68.6123,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808415 0 0 0 0 0.94851 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10903_6754"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_10903_6754",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_10903_6754",
  x1: 22.8535,
  y1: 15.1079,
  x2: 719.989,
  y2: 670.39,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCDAFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1B6F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_10903_6754",
  x1: 33.4844,
  y1: 45,
  x2: 33.4844,
  y2: 605.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_10903_6754",
  x1: 104,
  y1: 45,
  x2: 104,
  y2: 605.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_10903_6754",
  x1: 174.516,
  y1: 45,
  x2: 174.516,
  y2: 605.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_10903_6754",
  x1: 245.039,
  y1: 45,
  x2: 245.039,
  y2: 605.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_10903_6754",
  x1: 315.555,
  y1: 45,
  x2: 315.555,
  y2: 605.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_10903_6754",
  x1: 386.07,
  y1: 45,
  x2: 386.07,
  y2: 605.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_10903_6754",
  x1: 456.344,
  y1: 45,
  x2: 456.344,
  y2: 697,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_10903_6754",
  x1: 527.344,
  y1: 45,
  x2: 527.344,
  y2: 697,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_10903_6754",
  x1: -87,
  y1: 429.137,
  x2: 671.048,
  y2: 429.137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_10903_6754",
  x1: -87,
  y1: 501.137,
  x2: 671.048,
  y2: 501.137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_10903_6754",
  x1: -87,
  y1: 581.137,
  x2: 671.048,
  y2: 581.137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_10903_6754",
  x1: -87,
  y1: 365.031,
  x2: 671.048,
  y2: 365.031,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_10903_6754",
  x1: -87,
  y1: 300.926,
  x2: 671.048,
  y2: 300.926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_10903_6754",
  x1: -87,
  y1: 236.82,
  x2: 671.048,
  y2: 236.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_10903_6754",
  x1: -87,
  y1: 172.713,
  x2: 671.048,
  y2: 172.713,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_10903_6754",
  x1: -87,
  y1: 108.605,
  x2: 671.048,
  y2: 108.605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_10903_6754",
  x1: -87,
  y1: 44.5,
  x2: 671.048,
  y2: 44.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_10903_6754",
  x1: 465.059,
  y1: 349.88,
  x2: 444.545,
  y2: 349.88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8D5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_10903_6754",
  x1: 213.76,
  y1: 492.478,
  x2: 132.986,
  y2: 492.478,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8D5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_10903_6754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(563.954 209.528) rotate(-180) scale(57.798)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB73F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#EED0FD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_10903_6754",
  x1: 411.263,
  y1: 705.238,
  x2: 500.531,
  y2: 660.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_10903_6754",
  x1: 507.396,
  y1: 243.305,
  x2: 507.396,
  y2: 340.586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AAE3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint23_radial_10903_6754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(507.455 243.361) rotate(180) scale(32.7932)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB73F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#EED0FD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_10903_6754",
  x1: 499.538,
  y1: 237.632,
  x2: 525.353,
  y2: 264.015,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDFAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0E7FA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_10903_6754",
  x1: 458,
  y1: 711.422,
  x2: -62.5,
  y2: 561.355,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#84D9F6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.248671,
  stopColor: "#84D9F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EEFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_10903_6754",
  x1: 409.874,
  y1: 280.328,
  x2: 409.874,
  y2: 350.826,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AAE3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint27_radial_10903_6754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(410.012 280.012) rotate(180) scale(14.1294)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB73F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#EED0FD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_10903_6754",
  x1: 54,
  y1: 514.5,
  x2: 27,
  y2: 514.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BCE0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4F2FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_10903_6754",
  x1: 114,
  y1: 338.001,
  x2: 341.5,
  y2: 180.001,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AF42E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB73F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear_10903_6754",
  x1: 115.203,
  y1: 361.669,
  x2: 336.053,
  y2: 202.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AF42E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB73F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear_10903_6754",
  x1: 115.203,
  y1: 389.227,
  x2: 329.612,
  y2: 228.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AF42E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB73F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear_10903_6754",
  x1: 307.5,
  y1: 219.501,
  x2: 145,
  y2: 464.501,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8099F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear_10903_6754",
  x1: 229.905,
  y1: 188.492,
  x2: 229.905,
  y2: 274.432,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FB4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear_10903_6754",
  x1: 229.905,
  y1: 154.33,
  x2: 229.905,
  y2: 242.06,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FB4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear_10903_6754",
  x1: 229.475,
  y1: 119,
  x2: 229.475,
  y2: 213.55,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FB4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear_10903_6754",
  x1: 218.501,
  y1: 372.503,
  x2: 314.35,
  y2: 404.133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4053B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear_10903_6754",
  x1: 465.192,
  y1: 308.191,
  x2: 465.192,
  y2: 393.536,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AAE3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint38_radial_10903_6754",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(465.242 308.242) rotate(180) scale(28.7693)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB73F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#EED0FD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear_10903_6754",
  x1: 338.792,
  y1: 386,
  x2: 338.792,
  y2: 534.237,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDDBFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0E7FA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint40_linear_10903_6754",
  x1: 335.52,
  y1: 424.484,
  x2: 335.52,
  y2: 666.067,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D70CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear_10903_6754",
  x1: 261.561,
  y1: 386,
  x2: 261.561,
  y2: 561.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D70CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint42_linear_10903_6754",
  x1: 475.925,
  y1: 642.522,
  x2: 16.0029,
  y2: 642.522,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint43_linear_10903_6754",
  x1: 542.012,
  y1: 684.888,
  x2: -38,
  y2: 684.888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint44_linear_10903_6754",
  x1: 620.015,
  y1: 739.494,
  x2: -87,
  y2: 739.494,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint45_linear_10903_6754",
  x1: 423.848,
  y1: 607.572,
  x2: 68.2534,
  y2: 607.572,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint46_linear_10903_6754",
  x1: 393.999,
  y1: 586.541,
  x2: 101.272,
  y2: 586.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint47_linear_10903_6754",
  x1: 358.792,
  y1: 561.303,
  x2: 137.035,
  y2: 561.303,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint48_linear_10903_6754",
  x1: 345.78,
  y1: 551.54,
  x2: 148.08,
  y2: 551.54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint49_linear_10903_6754",
  x1: 371.196,
  y1: 571.369,
  x2: 121.504,
  y2: 571.369,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint50_linear_10903_6754",
  x1: 398.266,
  y1: 366.797,
  x2: 420.43,
  y2: 355.602,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint51_linear_10903_6754",
  x1: 390.763,
  y1: 626.146,
  x2: 411.271,
  y2: 615.788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint52_linear_10903_6754",
  x1: 360.35,
  y1: 151.011,
  x2: 392.345,
  y2: 119.897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint53_linear_10903_6754",
  x1: 118.294,
  y1: 101.868,
  x2: 131.178,
  y2: 88.5552,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10903_6754"
}, /*#__PURE__*/React.createElement("rect", {
  width: 552,
  height: 800,
  fill: "white"
})));

function SvgOrganisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 800,
    viewBox: "0 0 552 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/Organisation.fa3e7b1853df4469b4608b6da9c0d962.svg";
export { ForwardRef as ReactComponent };